export default __webpack_public_path__ + "static/media/polyester1.1eb9dac8.jpg";